import React from 'react';
import { FormControlLabel, Tooltip } from '@mui/material';
import { Field } from '@innovyze/stylovyze/lib/components/Field';
import { useFormikContext, } from 'formik';
import * as Styled from './FieldSwitch.styles';
import { useGlobalization } from '../../contexts';
export const FieldSwitch = ({ name, label, toolTipHelperText, toolTipPlacement, arrow, dataCy, onChange, }) => {
    const { setFieldValue, setFieldTouched } = useFormikContext();
    const { t } = useGlobalization();
    return (React.createElement(Field, { name: name, onChange: (e) => {
            setFieldValue(name, e.target.checked);
            setFieldTouched(name, true, false);
            setTimeout(() => {
                onChange?.(e.target.checked);
            }, 100);
        } }, ({ field }) => (React.createElement(Styled.SwitchContainer, null,
        React.createElement(Styled.SwitchLabel, { variant: "text-medium", color: "secondary" }, label ?? ''),
        React.createElement(FormControlLabel, { ...field, label: field.value ? t('On') : t('Off'), control: toolTipHelperText ? (React.createElement(Tooltip, { arrow: true, title: t(toolTipHelperText), placement: toolTipPlacement },
                React.createElement(Styled.Switch, { "data-cy": dataCy || `field-${name}`, checked: field.value, color: "primary" }))) : (React.createElement(Styled.Switch, { "data-cy": dataCy || `field-${name}`, checked: field.value, color: "primary" })) })))));
};
